(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    // 🔴 21-oct-2026: LAS CLASES SOLO SE TOCAN SI CAMBIAN. classList.add/remove reescriben el
    // atributo class aunque la clase ya este (o no este): en cada evento de scroll, la cabecera
    // y la barra de anuncios (que copia sus clases) se marcaban como cambiadas, y con las reglas
    // :has() de la portada eso recalculaba y repintaba la pagina entera en cada fotograma. Medido
    // en la portada: 1.480 escrituras de class en una bajada y el documento repintado ~1.000 veces.
    ponerClase(cls, si) {
      if (this.header.classList.contains(cls) !== si) this.header.classList.toggle(cls, si);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.ponerClase('scrolled-past-header', true);
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.ponerClase('scrolled-past-header', true);
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.ponerClase('scrolled-past-header', false);
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      // 🔴 AQUI YA NO SE CIERRA NADA. Auditoria del 8-sep-2026: hide() llamaba a
      // closeMenuDisclosure/closeSearchModal/closeLocDisclosure. Eso tenia
      // sentido cuando la cabecera se escondia al bajar —un panel abierto se
      // habria ido con ella—, pero ahora la cabecera NO se mueve. Resultado
      // medido: el desplegable de idioma se cerraba con UNA muesca de rueda, y
      // al cerrarse tiraba el foco del teclado al principio del documento.
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    // 🔴 El desplegable de idioma/moneda tambien. Al hacer scroll hacia abajo la
    // barra se va hacia arriba, pero este panel se quedaba flotando solo:
    // medido, 199-229px de desplegable sin barra de la que colgar.
    closeLocDisclosure() {
      const loc = document.getElementById('Details-sl-loc');
      if (!loc || !loc.hasAttribute('open')) return;
      loc.removeAttribute('open');
      const disparador = loc.querySelector('summary');
      if (disparador) disparador.setAttribute('aria-expanded', 'false');
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class luminLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lumin-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', luminLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-video-new"] && !Shopify.designMode) return;
  try {
    
class KsShoppableVideos extends HTMLElement {
  constructor () {
    super()
/*
    if (!document.querySelector('#swiper-stylesheet')) {
      const stylesheet = document.createElement('link')
      stylesheet.setAttribute('href', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.css')
      stylesheet.setAttribute('rel', 'stylesheet')
      stylesheet.setAttribute('id', 'swiper-stylesheet')
      stylesheet.setAttribute('integrity', 'sha256-5nkrwjVsiNfKz3NR1k2h5+qt5pS5SF2u9/TIT1hElow=')
      stylesheet.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(stylesheet)
    }

    if (!document.querySelector('#swiper-script')) {
      const script = document.createElement('script')
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.js')
      script.setAttribute('id', 'swiper-script')
      script.setAttribute('integrity', 'sha256-rCACDWCp/VzIh0rsB+ipQCM9XBvO8HNe0fNSOa4sys0=')
      script.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(script)
    }
*/
    setTimeout(() => {
      const slider = new window.Swiper(this.querySelector('.swiper'), this.splideOptions())

      slider.on('slideChange', () => {
        this.querySelector('.swiper').classList.add('swiper-is-changing')
        this.onSlideChange()
      })

      slider.on('slideChangeTransitionEnd', () => {
        this.querySelector('.swiper').classList.remove('swiper-is-changing')
      })
    }, 500)
    
    this.querySelectorAll('.lumin-shoppable-videos-btn-play').forEach(btn => {
      btn.addEventListener('click', () => {
        const video = btn.closest('.lumin-shoppable-videos-video-wrapper').querySelector('video')
        this.onVideoPlay(video)
      })
    })

    this.querySelectorAll('video').forEach(video => {
      video.addEventListener('click', () => {
        this.onVideoPlay(video)
      })
    })

    const lazyVideosObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.play()
        }
      })
    }, { rootMargin: '0px 0px 300px 0px' })
    
    this.querySelectorAll('video[data-autoplay="true"]').forEach((el) => {
      lazyVideosObserver.observe(el)
    })
  }

  splideOptions () {
    const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1

    /** @type {SwiperOptions} */
    const options = {
      rewind: true,
      speed: Number(this.dataset.sliderSpeed),
      breakpoints: {
        0: { slidesPerView: Number(this.dataset.breakpointXs) * partialSlidesMobile },
        576: { slidesPerView: Number(this.dataset.breakpointSm) },
        768: { slidesPerView: Number(this.dataset.breakpointMd) },
        992: { slidesPerView: Number(this.dataset.breakpointLg) },
        1200: { slidesPerView: Number(this.dataset.breakpointXl) },
        1400: { slidesPerView: Number(this.dataset.breakpointXxl) }
      },
      navigation: {
        enabled: this.dataset.sliderNav === 'true',
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      pagination: {
        enabled: this.dataset.sliderPagination === 'true',
        type: this.dataset.sliderPaginationType,
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 2,
        renderFraction: function (currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
        }
      },
      scrollbar: {
        enabled: this.dataset.sliderScrollbar === 'true',
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true
        // hide: true
      },
      autoplay: this.dataset.sliderAutoplay !== '0'
        ? { delay: Number(this.dataset.sliderAutoplay) * 1000 }
        : undefined,
      watchSlidesProgress: true, 
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
    }
    return options
  }

  onSlideChange () {
    this.querySelectorAll('.lumin-shoppable-videos-card').forEach(elem => {
      elem.setAttribute('data-is-playing', 'false')
      elem.querySelector('video')?.pause()
    })
  }

  onVideoPlay (video) {
    const card = video.closest('.lumin-shoppable-videos-card')

    this.querySelectorAll('.lumin-shoppable-videos-card').forEach(elem => {
      if (elem.dataset.index !== card.dataset.index) {
        elem.setAttribute('data-is-playing', 'false')
        elem.querySelector('video')?.pause()
      }
    })
    
    if (card.dataset.isPlaying === 'true') {
      card.setAttribute('data-is-playing', 'false')
      video.pause()
    } else {
      card.setAttribute('data-is-playing', 'true')
      video.muted = false
      video.play()
    }
  }
}
customElements.define('lumin-shoppable-videos', KsShoppableVideos)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-hero-banner"] && !Shopify.designMode) return;
  try {
    
class SlHeroCarousel {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('[data-hero-track]');
    this.slides = Array.from(root.querySelectorAll('[data-hero-slide]'));
    this.dots = Array.from(root.querySelectorAll('[data-hero-dot]'));
    // 🔴 LAS TARJETAS VIVEN FUERA DEL CARRUSEL, asi que hay que subir a la seccion
    //    para encontrarlas: `root` es solo el visor. Estan fuera a proposito —el
    //    carril tiene `overflow-x: auto` y recortaria cualquier cosa que cuelgue de
    //    una diapositiva—.
    this.seccion = root.closest('.sl-hero');
    this.tira = this.seccion ? this.seccion.querySelector('[data-hero-zapas]') : null;
    this.zapas = this.tira ? Array.from(this.tira.querySelectorAll('[data-hero-zapa]')) : [];
    this.index = 0;
    this.timer = null;
    if (!this.track || this.slides.length < 2) return;

    // 🔴 LAS DIAPOSITIVAS 2 EN ADELANTE SE PIDEN DESPUES DE LA PRIMERA (14-oct-2026). Con la
    // carga diferida del navegador se bajaban a la vez que la primera (estan al lado, dentro de
    // su margen): 194 KB compitiendo con la foto que hay que pintar. Llegan con data-srcset y se
    // ponen de verdad cuando la primera termina de cargar (o a los 5 s), al tocar el banner o
    // antes de pasar de diapositiva.
    this.cargarDiapos = () => {
      if (this.diaposCargadas) return;
      this.diaposCargadas = true;
      root.querySelectorAll('[data-srcset], [data-src]').forEach((el) => {
        if (el.dataset.srcset) { el.srcset = el.dataset.srcset; el.removeAttribute('data-srcset'); }
        if (el.dataset.src) { el.src = el.dataset.src; el.removeAttribute('data-src'); }
      });
    };
    const primeraFoto = this.slides[0].querySelector('img');
    if (!primeraFoto || primeraFoto.complete) setTimeout(this.cargarDiapos, 0);
    else {
      primeraFoto.addEventListener('load', this.cargarDiapos, { once: true });
      primeraFoto.addEventListener('error', this.cargarDiapos, { once: true });
      setTimeout(this.cargarDiapos, 5000);
    }
    root.addEventListener('pointerdown', this.cargarDiapos, { once: true, passive: true });
    root.addEventListener('touchstart', this.cargarDiapos, { once: true, passive: true });

    this.slides.forEach((s, i) => { s.dataset.slLogico = i; });
    this.actual = this.slides[0];
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.interval = parseInt(root.dataset.interval, 10) || 6000;
    // 🔴 EN EL EDITOR NO GIRA SOLO. Auditoria del 8-sep-2026: mientras editabas el
    // banner, el carrusel seguia pasando diapositivas y te sacaba de la que
    // estabas tocando.
    this.enEditor = !!(window.Shopify && window.Shopify.designMode);
    this.wantsAutoplay = root.dataset.autoplay === 'true' && !this.reduced && !this.enEditor;
    this.tapado = !!root.closest('[inert]');

    // Sin autoplay no hay cuenta atras que enseñar: la barra sobra.
    if (this.tira && !this.wantsAutoplay) this.tira.classList.add('sl-hero__zapas--sin-tiempo');

    this.bind();
    this.observe();
    if (this.wantsAutoplay) this.start();
  }

  bind() {
    const prev = this.root.querySelector('[data-hero-prev]');
    const next = this.root.querySelector('[data-hero-next]');
    this.prevBtn = prev;
    this.nextBtn = next;
    if (prev) prev.addEventListener('click', () => { this.stop(); this.paso(-1); });
    if (next) next.addEventListener('click', () => { this.stop(); this.paso(1); });
    this.dots.forEach((d) => d.addEventListener('click', () => {
      this.stop();
      this.irA(parseInt(d.dataset.go, 10));
    }));
    this.root.addEventListener('pointerenter', () => this.stop());
    this.root.addEventListener('pointerleave', () => { if (this.wantsAutoplay) this.start(); });
    this.root.addEventListener('focusin', () => this.stop());

    // 🔴 EL RATON SOBRE UNA TARJETA SALTA A SU BANNER (Jorge, 14-sep-2026). Tres
    //    decisiones tomadas a sabiendas:
    //    · Solo con puntero FINO. En tactil no existe «pasar por encima»: el dedo
    //      que toca ya viene a pulsar, y cambiarle el banner debajo le robaria el
    //      clic al producto.
    //    · El FOCO no salta. La tarjeta es un enlace a la ficha, no un boton de
    //      carrusel: mover el banner al tabular seria un efecto secundario que
    //      nadie ha pedido. Para ir de banner en banner con teclado estan las
    //      flechas.
    //    · La tira no es `this.root`, asi que la pausa del autoplay que ya existia
    //      NO la cubria: hay que pausarla aqui o la cuenta seguiria corriendo
    //      mientras miras una zapatilla.
    this.zapas.forEach((z) => {
      z.addEventListener('pointerenter', (e) => {
        if (e.pointerType === 'touch') return;
        this.stop();
        this.irA(parseInt(z.dataset.go, 10));
      });
    });
    if (this.tira) {
      this.tira.addEventListener('pointerleave', () => { if (this.wantsAutoplay) this.start(); });
      this.tira.addEventListener('focusin', () => this.stop());
      this.tira.addEventListener('focusout', (e) => {
        // saltar entre tarjetas no es salir de la tira
        if (this.tira.contains(e.relatedTarget)) return;
        if (this.wantsAutoplay) this.start();
      });
    }
    this.track.addEventListener('pointerdown', () => { this.stop(); this.cortar(); }, { passive: true });
    // 🔴 EL CARRIL SE RECONCILIA CADA VEZ QUE SE QUEDA QUIETO. Revision del
    // 7-sep-2026, reproducido: si el usuario toca el carril durante los primeros
    // ~100ms de una transicion —en movil basta con apoyar el dedo para hacer
    // scroll VERTICAL de la pagina sobre el banner—, cortar() devolvia el iman,
    // el navegador reencajaba en la diapositiva de PARTIDA, y el punto se
    // quedaba marcando la de destino PARA SIEMPRE. Medido: descuadrado todavia
    // 2,5s despues. El observador no lo salvaba porque la de partida baja de 1.0
    // a 0.7 y vuelve a subir sin CRUZAR nunca el 0.55, asi que no dispara.
    // Escuchando el scroll con un respiro cubre esto y ademas cualquier arrastre
    // con el dedo que acabe a medio camino.
    this.track.addEventListener('scroll', () => {
      clearTimeout(this.reposo);
      this.reposo = setTimeout(() => { if (!this.raf) this.sincronizar(); }, 140);
    }, { passive: true });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) this.stop();
      else if (this.wantsAutoplay) this.start();
    });
  }

  observe() {
    this.io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (this.enMarcha) return;      // movimiento nuestro: el indice ya esta puesto
        if (e.isIntersecting && e.intersectionRatio > 0.55) {
          this.actual = e.target;      // arrastre con el dedo: manda lo que se ve
          this.index = parseInt(e.target.dataset.slLogico, 10);
          this.paint();
        }
      });
    }, { root: this.track, threshold: [0.55] });
    this.slides.forEach((s) => this.io.observe(s));
  }

  // 🔴 PARA REINICIAR UNA ANIMACION CSS NO BASTA CON QUITAR Y PONER LA CLASE EN LA
  //    MISMA VUELTA: el navegador une las dos escrituras y no ve ningun cambio. Hay
  //    que forzar un reflow leyendo una medida en medio.
  reiniciarTiempo() {
    if (!this.zapas.length) return;
    const activa = this.zapas.find((z) => z.classList.contains('is-active'));
    if (!activa) return;
    const barra = activa.querySelector('.sl-hero__zapa-tiempo');
    if (!barra) return;
    barra.style.animation = 'none';
    void barra.offsetWidth;
    barra.style.animation = '';
  }

  paint() {
    this.zapas.forEach((z) => {
      const on = parseInt(z.dataset.go, 10) === this.index;
      z.classList.toggle('is-active', on);
      if (on) z.setAttribute('aria-current', 'true');
      else z.removeAttribute('aria-current');
    });
    this.reiniciarTiempo();
    // Ninguna flecha se apaga: el carrusel es circular, las dos llevan siempre
    // a algun sitio.
    this.dots.forEach((d, i) => {
      const on = i === this.index;
      d.classList.toggle('is-active', on);
      if (on) d.setAttribute('aria-current', 'true');
      else d.removeAttribute('aria-current');
    });
  }

  // 🔴 LA VUELTA SE DESLIZA, Y HACIA EL LADO CORRECTO. Jorge, 7-sep-2026:
  // «quiero que haga la transicion tambien».
  //
  // El problema de fondo: un carrusel de scroll no puede ir «de la ultima a la
  // primera» animando, porque la primera esta al principio del carril — animar
  // hasta ella es recorrer los 2880px hacia atras, que es exactamente el fallo
  // que Jorge reporto («cuando pulsas hacia atras va hacia delante»).
  //
  // La solucion no es animar mas rapido ni saltar: es MOVER LA DIAPOSITIVA DE
  // SITIO antes de animar. Estando en la ultima y pulsando «siguiente», cojo la
  // primera del DOM y la pego al final; el carril se ha acortado por la
  // izquierda, asi que descuento un ancho al scroll en el mismo fotograma para
  // que visualmente no se mueva nada. Ahora la primera esta a mi derecha, y el
  // destino vuelve a ser la contigua: un paso normal, deslizado, hacia delante.
  //
  // Consecuencia: TODOS los movimientos de flecha son de una diapositiva. No
  // hay caso especial, no hay salto, y la direccion nunca puede leerse al reves.
  // El precio es que el orden del DOM deja de coincidir con el orden logico —de
  // ahi que el indice y los puntos vayan por data-sl-logico y no por posicion.
  // 🔴 LOS CLICS SE ENCOLAN Y EL CARRIL SOLO SE REORDENA EN REPOSO.
  // Jorge, 7-sep-2026: «si le doy muy rapido a las flechas es como que se raya».
  // Dos causas, las dos medidas:
  //  1. La vuelta compensa la reordenacion con scrollLeft -= ancho, y eso solo
  //     cabe si queda un ancho por delante. En reposo siempre cabe; a media
  //     animacion no —con dos diapositivas la cuenta se iba por debajo de cero,
  //     el navegador RECORTABA la compensacion, y ese recorte era el tiron—.
  //  2. Encadenando pasos se perdia un fotograma en cada empalme: la animacion
  //     terminaba, devolvia el control, y el tramo siguiente no empezaba a
  //     pintar hasta el fotograma de despues. Un parpadeo por paso.
  // Solucion: un unico bucle que nunca suelta el mando. Cuando un tramo acaba,
  // el siguiente se prepara y se pinta DENTRO DEL MISMO FOTOGRAMA, arrastrando
  // el tiempo sobrante para que no se pierda ni un milisegundo.
  paso(dir) {
    if (this.cargarDiapos) this.cargarDiapos();
    // 🔴 AL ARRANCAR UNA CADENA, MANDA LA PANTALLA. Dentro de una cadena hay que
    // fiarse de this.actual (el carril esta a medio camino y no se puede leer),
    // pero si no hay nada en marcha el carril esta parado en un hueco exacto y
    // lo que se ve es mas fiable que el estado. Sin esto, tras un corte a media
    // transicion el ancla apuntaba a una diapositiva que nunca llego, y la
    // "alineacion previa" de prepararTramo dejaba de ser un no-op para
    // convertirse en un salto de un ancho entero: un solo clic avanzaba dos, la
    // primera mitad de un tiron seco.
    if (!this.raf) this.sincronizar();
    if (this.raf) this.encadenado = true;      // ha llegado con algo en marcha
    this.cola = Math.max(-6, Math.min(6, (this.cola || 0) + dir));
    if (!this.raf) this.arrancar(performance.now());
  }

  arrancar(t0) {
    if (!this.prepararTramo(t0)) { this.acabar(); return; }
    this.raf = requestAnimationFrame((t) => this.bucle(t));
  }

  // Reordena (si toca) y deja listo el tramo siguiente. Devuelve false si no
  // queda nada que hacer. SIEMPRE se llama con el carril parado en un hueco
  // exacto, que es la unica situacion en la que la compensacion cabe entera.
  prepararTramo(t0) {
    if (!this.cola) return false;
    const dir = this.cola > 0 ? 1 : -1;
    this.cola -= dir;

    let carril = Array.from(this.track.querySelectorAll('[data-hero-slide]'));
    const n = carril.length;
    const ancho = carril[0].offsetWidth;
    if (!ancho) return false;
    // El ancla es la DIAPOSITIVA, no el scrollLeft: un numero a medio camino
    // redondea al hueco equivocado. El scroll solo es la red por si se pierde.
    const desde = (this.actual && carril.indexOf(this.actual) >= 0)
      ? this.actual
      : carril[Math.max(0, Math.min(n - 1, Math.round(this.track.scrollLeft / ancho)))];
    const aqui = carril.indexOf(desde);
    const cero0 = carril[0].offsetLeft;

    this.track.style.scrollSnapType = 'none';
    // Alinear antes de mover ningun nodo. No se ve —ya estamos ahi— y garantiza
    // que la compensacion de abajo no se salga de rango.
    this.track.scrollLeft = desde.offsetLeft - cero0;

    if (dir > 0 && aqui === n - 1) {
      this.track.appendChild(carril[0]);
      this.track.scrollLeft -= ancho;
    } else if (dir < 0 && aqui === 0) {
      this.track.insertBefore(carril[n - 1], carril[0]);
      this.track.scrollLeft += ancho;
    }

    carril = Array.from(this.track.querySelectorAll('[data-hero-slide]'));
    const destino = carril[carril.indexOf(desde) + dir];
    if (!destino) return false;

    this.actual = destino;
    this.index = parseInt(destino.dataset.slLogico, 10);
    this.enMarcha = true;          // el observador no toca el indice mientras dura
    this.paint();

    const x2 = destino.offsetLeft - carril[0].offsetLeft;
    if (this.reduced) { this.track.scrollLeft = x2; this.cola = 0; return false; }

    // Un paso suelto frena al llegar. Los tramos intermedios de una cadena van a
    // velocidad constante y solo frena el ultimo, para que seis clics seguidos
    // se lean como un desplazamiento largo y no como seis tirones pegados. La
    // frenada final dura mas para entrar a la misma velocidad que traia.
    const intermedio = this.cola !== 0;
    this.tramo = {
      x1: this.track.scrollLeft, x2, t0,
      ms: intermedio ? 200 : (this.encadenado ? 620 : 460),
      recto: intermedio
    };
    return true;
  }

  bucle(t) {
    // Un tramo puede haber acabado hace rato si el navegador se salto
    // fotogramas: se consumen todos los vencidos arrastrando el tiempo sobrante.
    while (this.tramo && t - this.tramo.t0 >= this.tramo.ms) {
      const fin = this.tramo.t0 + this.tramo.ms;
      this.track.scrollLeft = this.tramo.x2;
      this.tramo = null;
      if (this.cola) this.prepararTramo(fin);
    }
    if (!this.tramo) { this.raf = 0; this.acabar(); return; }
    const s = this.tramo;
    const p = Math.max(0, Math.min(1, (t - s.t0) / s.ms));
    this.track.scrollLeft = s.x1 + (s.x2 - s.x1) * (s.recto ? p : 1 - Math.pow(1 - p, 3));
    this.raf = requestAnimationFrame((tt) => this.bucle(tt));
  }

  // Los puntos son un destino explicito: el usuario ha señalado a cual quiere ir,
  // asi que aqui si vale recorrer el carril —no hay direccion que malinterpretar—.
  irA(logico) {
    if (this.cargarDiapos) this.cargarDiapos();
    const carril = Array.from(this.track.querySelectorAll('[data-hero-slide]'));
    const destino = carril.find((s) => parseInt(s.dataset.slLogico, 10) === logico);
    if (!destino || destino === this.actual) return;
    cancelAnimationFrame(this.raf);
    this.cola = 0;
    this.encadenado = false;
    this.actual = destino;
    this.index = logico;
    this.enMarcha = true;
    this.paint();
    const x2 = destino.offsetLeft - carril[0].offsetLeft;
    if (this.reduced) { this.track.scrollLeft = x2; this.acabar(); return; }
    this.track.style.scrollSnapType = 'none';
    this.tramo = { x1: this.track.scrollLeft, x2, t0: performance.now(), ms: 460, recto: false };
    this.raf = requestAnimationFrame((t) => this.bucle(t));
  }

  // El dedo manda: si el usuario empieza a arrastrar, nos apartamos y tiramos la
  // cola —lo que quiera hacer ahora pesa mas que lo que pidio hace medio segundo—.
  cortar() {
    cancelAnimationFrame(this.raf);
    this.raf = 0;
    this.tramo = null;
    this.cola = 0;
    this.encadenado = false;
    this.enMarcha = false;
    this.track.style.scrollSnapType = '';
  }

  acabar() {
    this.raf = 0;
    this.tramo = null;
    this.cola = 0;
    this.encadenado = false;
    this.enMarcha = false;
    this.track.style.scrollSnapType = '';
    this.sincronizar();
  }

  // 🔴 AL SOLTAR, LA PANTALLA MANDA. El observador solo se despierta al cruzar
  // el 55%: si la diapositiva ya llevaba rato entera en pantalla, ese cruce no
  // vuelve a pasar y un desajuste no se corregiria solo. Aqui ya no hay nada en
  // marcha, asi que leer el carril es seguro: lo que se ve es la verdad.
  sincronizar() {
    const carril = Array.from(this.track.querySelectorAll('[data-hero-slide]'));
    if (!carril.length) return;
    const ancho = carril[0].offsetWidth;
    if (!ancho) return;
    const i = Math.max(0, Math.min(carril.length - 1, Math.round(this.track.scrollLeft / ancho)));
    if (carril[i] === this.actual) return;
    this.actual = carril[i];
    this.index = parseInt(carril[i].dataset.slLogico, 10);
    this.paint();
  }

  start() {
    // Tapado por las tarjetas del apilado no gira (ver revisar() en slApilar).
    if (this.tapado) return;
    this.stop();
    this.timer = setInterval(() => this.paso(1), this.interval);
    // 🔴 EL RELOJ Y LA BARRA ARRANCAN JUNTOS. `setInterval` empieza de cero cada
    //    vez que se reanuda; si la barra se quedase donde la dejo la pausa,
    //    llegaria al final antes de tiempo y se quedaria llena esperando.
    this.reiniciarTiempo();
  }

  stop() {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
  }
}

// 🔴 EL HERO SE APAGA CUANDO DEJA DE VERSE. Auditoria del 8-sep-2026,
// reproducido: con la pagina bajada, al tabular desde la cabecera se pasaba por
// el CTA del banner, las dos flechas y los puntos SIN VER NADA — el hero sigue
// dentro de la ventana porque esta clavado, asi que el navegador no desplaza
// para enseñarlo, pero las secciones que suben lo tapan. Cinco paradas ciegas, y
// una es un enlace: pulsar Enter te llevaba a otra pagina sin saber a donde.
// Antes de clavarlo no pasaba, porque el hero se iba fuera de la ventana y el
// navegador lo traia a la vista al enfocarlo.
// `inert` lo saca del tabulador y del arbol de accesibilidad de una vez, sin
// tocar el CSS ni el orden visual.
// 🔴 EL EDITOR DE TEMAS, ATENDIDO. Auditoria del 8-sep-2026:
//  · seleccionar la seccion Banner no la traia a la vista, porque va clavada y
//    el editor no encuentra a donde desplazar;
//  · seleccionar una diapositiva no saltaba a ella, asi que editabas a ciegas.
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:select', function (e) {
    if (!e.target.querySelector || !e.target.querySelector('.sl-hero')) return;
    var env = e.target.closest('#MainContent > *') || e.target;
    window.scrollTo({ top: Math.max(0, env.offsetTop - 120), behavior: 'smooth' });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.matches && e.target.matches('[data-hero-slide]')
      ? e.target
      : (e.target.closest ? e.target.closest('[data-hero-slide]') : null);
    if (!slide) return;
    var raiz = slide.closest('[data-hero-carousel]');
    if (!raiz || !raiz.slHero) return;
    raiz.slHero.stop();
    raiz.slHero.irA(parseInt(slide.dataset.slLogico, 10));
  });
}

// 🔴 slApilar() YA NO VIVE AQUI (13-oct-2026): va en linea en el marcado de esta seccion
// (busca «EL APILADO SE MONTA EN CUANTO LLEGA EL HTML»). Este fichero se sirve diferido y
// con mala conexion llegaba a los 17-20s; hasta entonces las colecciones se veian como una
// lista plana y luego se recolocaban bajo el dedo. Desde aqui solo se le vuelve a llamar.

// 🔴 CUANTO MIDE LA TIRA DE ZAPATILLAS, PARA QUE EL TEXTO LA ESQUIVE.
// La tira va absoluta al pie del banner. Cuando cae en modo franja se planta
// justo donde acaba el bloque de texto, y su alto depende de en cuantas lineas
// parta el nombre del producto: 44, 58 o 78px medidos el 22-sep-2026. Escribir
// esos numeros a mano dura hasta que alguien cambie un titulo, asi que se miden.
// En modo esquina la tira no estorba y se publica 0.
function slHeroAireTira(hero) {
  const tira = hero.querySelector('.sl-hero__zapas');
  if (!tira) return;
  const anchoHero = hero.getBoundingClientRect().width;
  const rt = tira.getBoundingClientRect();
  const franja = Math.round(rt.width) >= Math.round(anchoHero) - 1;
  // 🔴 NO ES EL ALTO DE LA TIRA, ES LO QUE HAY QUE SUBIR. La tira tampoco se
  // apoya siempre a la misma distancia del canto: a 390 su pie queda a 38px del
  // borde y a 880 a 70px. Midiendo del borde de abajo del banner al TOPE de la
  // tira, las dos variables quedan dentro de un solo numero y el hueco sale
  // constante en todos los anchos.
  const val = (franja ? Math.ceil(hero.getBoundingClientRect().bottom - rt.top) : 0) + 'px';
  // 🔴 SOLO SE ESCRIBE SI CAMBIA: el ResizeObserver que llama aqui vigila la
  // propia tira, y escribir a ciegas lo vuelve a disparar en bucle.
  if (hero.style.getPropertyValue('--sl-zapas-alto') !== val) {
    hero.style.setProperty('--sl-zapas-alto', val);
  }
}

function slHeroInit() {
  document.querySelectorAll('[data-hero-carousel]').forEach((el) => {
    if (!el.slHero) el.slHero = new SlHeroCarousel(el);
  });
  document.querySelectorAll('.sl-hero').forEach((hero) => {
    // Una vez por fotograma como mucho, y siempre justo antes de pintar (14-oct-2026: la tira y
    // sus miniaturas disparaban esto muchas veces seguidas al cargar, y la primera llamada, a
    // mitad de la carga, obligaba a recalcular la pagina entera: 252 ms con la CPU x4).
    if (!hero.slAireTira) {
      let pendiente = false;
      hero.slAireTira = () => {
        if (pendiente) return;
        pendiente = true;
        requestAnimationFrame(() => { pendiente = false; slHeroAireTira(hero); });
      };
    }
    const recalcular = hero.slAireTira;
    recalcular();
    if (hero.dataset.aireAtado) return;
    hero.dataset.aireAtado = '1';
    window.addEventListener('resize', recalcular, { passive: true });
    const tira = hero.querySelector('.sl-hero__zapas');
    if (tira && 'ResizeObserver' in window) new ResizeObserver(recalcular).observe(tira);
    // las miniaturas cargan tarde y pueden cambiar el alto de la tarjeta
    hero.querySelectorAll('.sl-hero__zapa-foto img').forEach((img) => {
      if (!img.complete) img.addEventListener('load', recalcular, { once: true });
    });
  });
  if (window.slApilar) window.slApilar();
  slHeroTecho();
}

// 🔴 EL TECHO TAMBIEN SIN LA PORTADA NUEVA. El texto «arriba» en movil se coloca
// bajo la cabecera flotante con `--sl-techo`, que media slApilar. Sin la portada
// nueva slApilar no corre y quedaba el respaldo de 97px: en el tema en vivo la
// cabecera acaba en 102 (movil) y 117 (ordenador). Se mide igual, con la pagina
// arriba del todo, que es cuando el banner esta debajo de la cabecera.
function slHeroTecho() {
  if (document.querySelector('.sl-hero--portada')) return;
  if (window.slHeroTechoAtado) return;
  window.slHeroTechoAtado = true;
  const medir = () => {
    if (window.scrollY > 4) return;
    const b = document.querySelector('.section-header');
    if (!b) return;
    const t = Math.max(0, Math.round(b.getBoundingClientRect().bottom));
    const raiz = document.documentElement;
    if (raiz.style.getPropertyValue('--sl-techo') !== t + 'px') raiz.style.setProperty('--sl-techo', t + 'px');
  };
  medir();
  window.addEventListener('resize', medir, { passive: true });
  window.addEventListener('load', medir);
}

document.addEventListener('DOMContentLoaded', slHeroInit);
document.addEventListener('shopify:section:load', slHeroInit);
slHeroInit();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-shop-the-look"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('sl-shop-the-look')) return;

  class SlShopTheLook extends HTMLElement {
    connectedCallback() {
      if (this.montado) return;
      this.montado = true;
      try {
        this.montar();
      } catch (err) {
        console.error('[sl-shop-the-look]', err);
      }
    }

    // 🔴 AL QUITAR LA SECCION (el editor la repinta) SE PARA TODO: el reloj, el
    // observador y los oyentes de la ventana. Si no, quedarian girando contra
    // tarjetas que ya no existen.
    disconnectedCallback() {
      this.montado = false;
      this.parar();
      if (this.io) this.io.disconnect();
      window.removeEventListener('resize', this.alRedimensionar);
      document.removeEventListener('visibilitychange', this.alCambiarPestana);
      document.removeEventListener('shopify:block:select', this.alElegirBloque);
      document.removeEventListener('shopify:block:deselect', this.alSoltarBloque);
    }

    montar() {
      this.visor = this.querySelector('[data-stl-visor]');
      this.carril = this.querySelector('[data-stl-carril]');
      this.looks = Array.from(this.querySelectorAll('[data-stl-look]'));
      this.ant = this.querySelector('[data-stl-ant]');
      this.sig = this.querySelector('[data-stl-sig]');
      if (!this.visor || !this.carril || !this.looks.length) return;

      this.duracion = parseInt(this.dataset.duracion, 10) || 4000;
      this.reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoplay = this.dataset.autoplay !== 'false' && !this.reducido && this.looks.length > 1;
      this.indice = 0;
      this.desplazado = 0;
      this.paso = 0;
      this.porVista = 1;
      this.maximo = 0;
      this.transcurrido = 0;
      this.ultimo = 0;
      this.raf = null;
      this.visible = false;
      // Cada motivo de pausa por separado: el raton encima, el dedo apretado, el
      // foco dentro, la pestaña oculta, el editor, o que la hayan parado con un
      // clic. Con un solo booleano, salir con el raton reanudaba una pausa que
      // habia pedido otro.
      this.pausas = new Set();
      // 21-oct-2026: la cuenta atras es la animacion de CSS sl-stl-llenar; antes un bucle de JS
      // escribia la barra en cada fotograma, tambien mientras se deslizaba la pagina.
      this.style.setProperty('--sl-stl-ms', this.duracion + 'ms');
      this.classList.toggle('sin-autoplay', !this.autoplay);
      this.classList.add('is-pausada');
      this.addEventListener('animationend', (e) => {
        if (e.animationName !== 'sl-stl-llenar' || !this.autoplay) return;
        if (e.target.closest('[data-stl-look]') !== this.looks[this.indice]) return;
        this.siguiente();
      });

      this.medir();
      this.atarControles();
      this.atarArrastre();
      this.atarEditor();
      this.observar();
      this.activar(0, true);

      this.alRedimensionar = () => {
        clearTimeout(this.tRedimension);
        this.tRedimension = setTimeout(() => {
          this.medir();
          this.mover(this.desplazado, true);
        }, 160);
      };
      window.addEventListener('resize', this.alRedimensionar, { passive: true });
    }

    medir() {
      const primera = this.looks[0];
      const hueco = parseFloat(getComputedStyle(this.carril).columnGap) || 0;
      // Se mide la caja SIN la escala del 96% de las inactivas: `offsetWidth` no
      // ve las transformaciones, `getBoundingClientRect` si.
      this.paso = primera.offsetWidth + hueco;
      this.porVista = Math.max(1, Math.floor((this.visor.clientWidth + hueco) / this.paso));
      this.maximo = Math.max(0, this.looks.length - this.porVista);
    }

    mover(desplazado, alInstante) {
      this.desplazado = Math.max(0, Math.min(desplazado, this.maximo));
      if (alInstante) this.carril.classList.add('sin-animacion');
      this.carril.style.transform = 'translate3d(' + -this.desplazado * this.paso + 'px, 0, 0)';
      if (alInstante) {
        void this.carril.offsetWidth;
        this.carril.classList.remove('sin-animacion');
      }
    }

    // Que la activa quede dentro del visor: si se sale por la derecha, el carril
    // avanza lo justo para que sea la ultima visible; por la izquierda, la primera.
    asegurarVisible(i) {
      if (i < this.desplazado) this.mover(i);
      else if (i > this.desplazado + this.porVista - 1) this.mover(i - this.porVista + 1);
    }

    activar(i, alInstante) {
      if (i >= this.looks.length) {
        i = 0;
        this.mover(0);
      }
      if (i < 0) i = 0;
      this.indice = i;
      this.looks.forEach((look, n) => {
        const activa = n === i;
        look.classList.toggle('is-activa', activa);
        if (activa) look.setAttribute('aria-current', 'true');
        else look.removeAttribute('aria-current');
        const relleno = look.querySelector('[data-stl-relleno]');
        if (relleno) relleno.style.transform = 'scaleX(0)';
      });
      this.asegurarVisible(i);
      this.precargar();
      if (alInstante) this.carril.classList.remove('sin-animacion');
      this.reiniciar();
    }

    // Las que estan a punto de entrar se piden ya: con `lazy` el navegador no las
    // carga mientras esten fuera del visor, y entrarian en blanco.
    // 🔴 SOLO CON LA SECCION A LA VISTA. Hacerlo al montar descargaba 2 fotos en
    // movil y 5 en ordenador nada mas abrir la portada, con la seccion a 4.000px
    // por debajo (medido el 28-sep contando las peticiones).
    precargar() {
      if (!this.visible) return;
      for (let k = this.indice + 1; k <= this.indice + this.porVista + 1 && k < this.looks.length; k++) {
        const img = this.looks[k].querySelector('.sl-stl__foto');
        if (img && img.loading === 'lazy') img.loading = 'eager';
      }
    }

    siguiente() { this.activar(this.indice + 1 < this.looks.length ? this.indice + 1 : 0); }
    anterior() { this.activar(this.indice > 0 ? this.indice - 1 : 0); }

    reiniciar() {
      this.actualizarPausa();
      // La animacion arranca sola al pasar is-activa a otra tarjeta; si es la misma, se rebobina.
      const relleno = this.looks[this.indice] && this.looks[this.indice].querySelector('[data-stl-relleno]');
      const anim = relleno && relleno.getAnimations ? relleno.getAnimations()[0] : null;
      if (anim) anim.currentTime = 0;
    }

    actualizarPausa() {
      this.classList.toggle('is-pausada', !this.autoplay || !this.visible || this.pausas.size > 0);
    }

    parar() {
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = null;
    }

    pausar(motivo, si) {
      if (si) this.pausas.add(motivo);
      else this.pausas.delete(motivo);
      this.actualizarPausa();
    }

    // Solo gira mientras se ve al menos un cuarto de la seccion.
    observar() {
      this.alCambiarPestana = () => this.pausar('pestana', document.hidden);
      document.addEventListener('visibilitychange', this.alCambiarPestana);
      if (!('IntersectionObserver' in window)) {
        this.visible = true;
        this.actualizarPausa();
        return;
      }
      this.io = new IntersectionObserver((entradas) => {
        entradas.forEach((e) => {
          this.visible = e.isIntersecting;
          if (e.isIntersecting) this.precargar();
          this.actualizarPausa();
        });
      }, { threshold: 0.25 });
      this.io.observe(this);
    }

    atarControles() {
      if (this.ant) this.ant.addEventListener('click', () => this.anterior());
      if (this.sig) this.sig.addEventListener('click', () => this.siguiente());

      this.looks.forEach((look, n) => {
        look.addEventListener('click', (e) => {
          if (this.visor.classList.contains('is-arrastrando')) return;
          if (e.target.closest('a')) return;
          // 🔴 AL SOLTAR UNA PULSACION LARGA EL NAVEGADOR MANDA ADEMAS UN CLIC, y ese
          // clic caia aqui como «pausar»: el carrusel se quedaba parado para
          // siempre despues de mantener el dedo. Medido el 28-sep con toques
          // reales por CDP (la de thesolehunters hace lo mismo). Ese clic se ignora.
          if (this.pulsacionLarga) {
            this.pulsacionLarga = false;
            return;
          }
          if (n !== this.indice) {
            this.activar(n);
            return;
          }
          // Un clic en la activa la para o la reanuda (y lo que lleve la barra se
          // conserva).
          this.pausar('usuario', !this.pausas.has('usuario'));
        });
        // Tabulando: el foco entra en el boton de un look y ese look pasa a ser el
        // activo, con su carril desplazado hasta el.
        look.addEventListener('focusin', () => {
          if (n !== this.indice) this.activar(n);
        });
      });

      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        this.addEventListener('mouseenter', () => this.pausar('raton', true));
        this.addEventListener('mouseleave', () => this.pausar('raton', false));
      }
      this.addEventListener('focusin', () => this.pausar('foco', true));
      this.addEventListener('focusout', (e) => {
        if (!this.contains(e.relatedTarget)) this.pausar('foco', false);
      });

      // Mantener el dedo apretado pausa, como en las historias de Instagram.
      let espera = null;
      this.looks.forEach((look) => {
        look.addEventListener('touchstart', () => {
          clearTimeout(espera);
          this.pulsacionLarga = false;
          espera = setTimeout(() => {
            this.pulsacionLarga = true;
            this.pausar('toque', true);
          }, 240);
        }, { passive: true });
        const soltar = () => {
          clearTimeout(espera);
          this.pausar('toque', false);
        };
        look.addEventListener('touchend', soltar, { passive: true });
        look.addEventListener('touchcancel', soltar, { passive: true });
      });

      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.siguiente();
          this.enfocarActiva();
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.anterior();
          this.enfocarActiva();
        }
      });
    }

    // Con las flechas del teclado el foco acompaña al look: si se quedara en el
    // boton del anterior, el siguiente Tab volveria atras.
    enfocarActiva() {
      if (!this.contains(document.activeElement)) return;
      const boton = this.looks[this.indice].querySelector('.sl-stl__ver');
      if (boton) boton.focus({ preventScroll: true });
    }

    atarArrastre() {
      const visor = this.visor;
      let abajo = false;
      let x0 = 0;
      let y0 = 0;
      let base = 0;
      let eje = null;
      let id = null;

      const soltar = () => {
        this.carril.classList.remove('sin-animacion');
        this.pausar('arrastre', false);
      };

      visor.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        // Dentro del panel se pulsa, no se arrastra: si no, un clic con un
        // temblor de 6px en «Ver look» moveria el carril en vez de navegar.
        if (e.target.closest('[data-stl-panel]')) return;
        abajo = true;
        eje = null;
        id = e.pointerId;
        x0 = e.clientX;
        y0 = e.clientY;
        base = -this.desplazado * this.paso;
        this.pausar('arrastre', true);
        this.carril.classList.add('sin-animacion');
      });

      visor.addEventListener('pointermove', (e) => {
        if (!abajo || e.pointerId !== id) return;
        const dx = e.clientX - x0;
        const dy = e.clientY - y0;
        if (!eje && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) {
          eje = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          if (eje === 'y') {
            abajo = false;
            soltar();
            return;
          }
          try { visor.setPointerCapture(id); } catch (err) { /* ya soltado */ }
        }
        if (eje !== 'x') return;
        if (Math.abs(dx) > 5) visor.classList.add('is-arrastrando');
        let x = base + dx;
        const min = -this.maximo * this.paso;
        // Resistencia en los extremos, como la suya: se deja estirar un tercio.
        if (x > 0) x *= 0.35;
        else if (x < min) x = min + (x - min) * 0.35;
        this.carril.style.transform = 'translate3d(' + x + 'px, 0, 0)';
      });

      const fin = (e) => {
        if (!abajo || e.pointerId !== id) return;
        abajo = false;
        try { visor.releasePointerCapture(id); } catch (err) { /* ya soltado */ }
        this.carril.classList.remove('sin-animacion');
        if (eje === 'x') {
          const dx = e.clientX - x0;
          let salto = Math.round(-dx / this.paso);
          if (Math.abs(dx) > this.paso * 0.32 && salto === 0) salto = dx < 0 ? 1 : -1;
          this.mover(this.desplazado + salto);
          if (Math.abs(dx) > 8) this.activar(this.desplazado);
        }
        setTimeout(() => visor.classList.remove('is-arrastrando'), 60);
        soltar();
      };
      visor.addEventListener('pointerup', fin);
      visor.addEventListener('pointercancel', (e) => {
        if (e.pointerId !== id) return;
        abajo = false;
        this.mover(this.desplazado);
        visor.classList.remove('is-arrastrando');
        soltar();
      });
    }

    // En el editor de temas: al elegir un look en la barra lateral, se activa y
    // se queda quieto mientras se edita.
    atarEditor() {
      this.alElegirBloque = (e) => {
        if (!this.contains(e.target)) return;
        const n = this.looks.indexOf(e.target.closest('[data-stl-look]'));
        if (n < 0) return;
        this.pausar('editor', true);
        this.activar(n);
      };
      this.alSoltarBloque = (e) => {
        if (this.contains(e.target)) this.pausar('editor', false);
      };
      document.addEventListener('shopify:block:select', this.alElegirBloque);
      document.addEventListener('shopify:block:deselect', this.alSoltarBloque);
    }
  }

  customElements.define('sl-shop-the-look', SlShopTheLook);
})();

  } catch(e) { console.error(e); }
})();
})();
